import { useLocation } from "react-router-dom";
import React, { useEffect, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  InputAdornment,
  OutlinedInput,
  IconButton,
  CircularProgress,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "react-toastify/dist/ReactToastify.css";
import OtpInput from "react-otp-input";
import {
  resendRegisterOTP,
  setToken,
  setUserName,
  signInUser,
  verifyOTPAuth,
} from "../../actions/authActions";
import { useDispatch } from "react-redux";
import { toastMessage, zeroPad } from "../../helper";
import { EMAIL_REGEX } from "../../constants/regexConstants";
import { useTranslation } from "react-i18next";
import AppAuthSetup from "../AppAuth/AppAuthSetup";
import SessionsListView from "./SessionsListView";
import { MenuItem, Select } from "@mui/material";
const Login = (props: any) => {
  const { t, i18n } = useTranslation();
  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "green",
      },
    },
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateToForgotPassword = () => {
    // 👇️ navigate to /contacts
    navigate("/forgotpassword");
  };
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailAuthState, setIsEmailAuthState] = useState(false);
  const [isAppAuthState, setIsAppAuthState] = useState(false);
  const [otp, setOtp] = useState("");
  const [showTimer, setShowTimer] = useState(true);
  const [seconds, setSeconds] = useState(30);
  const [signupRes, setSignupRes] = useState();
  const [showAppAuthSetup, setShowAppAuthSetup] = useState(false);
  const [showSessionsListView, setShowSessionsListView] = useState(false);
  const [temporaryToken, setTemporaryToken] = useState(false);

  const { password, email } = formData;
  const validateForm = () => {
    return email && !emailError && password?.length >= 8 && !isLoading;
  };
  const onChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.type === "email") {
      validateEmail(e.target.value);
    }
  };
  const validateEmail = (email: string) => {
    setEmailError("");
    if (email) {
      //regex mail
      if (!EMAIL_REGEX.test(email)) {
        setEmailError("Invalid Email");
      }
    }
  };
  const location = useLocation();
  const fromPath = location.state?.from || null;
  const queryParams = new URLSearchParams(location.search);
  const accountTypes = ["Corporate", "Trainer"];
  const [accountType, setAccountType] = useState(
    queryParams.get("accountType") === "trainer" ? "Trainer" : "Corporate"
  );
  const handleAccountTypeChange = (type: string) => {
    setAccountType(type);
    localStorage.setItem("accountType", type);
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    const lowerCaseEmail = email.toLocaleLowerCase();
    setIsLoading(true);
    if (validateForm()) {
      signInUser(lowerCaseEmail, password, "login", accountType)
        .then((res: any) => {
          console.log("user data = ", res);
          localStorage.setItem("userName", lowerCaseEmail);
          localStorage.setItem("accountType", accountType);
          if (res.data.token && res.emptySessionId) {
            setTemporaryToken(res.data.token);
            setShowSessionsListView(true);
            return;
          }
          dispatch(setToken(res.data.token));
          if (res.data.token) {
            if (fromPath) {
              navigate(fromPath);
              return;
            }
            if (res.data.role === 5) {
              navigate("/partners/customers");
            } else {
              navigate("/home");
            }
          } else if (res.data.redirectToPending) {
            navigate("/coorporate-onboarding");
          } else if (res.data.redirectToOTP) {
            dispatch(setUserName(lowerCaseEmail));
            navigate("/verifyotp", {
              state: { username: lowerCaseEmail, password: password },
            });
          } else if (res.data.emailAuthRequired) {
            setSeconds(30);
            setShowTimer(true);
            setSignupRes(res);
            setIsEmailAuthState(true);
          } else if (res.data.appAuthRequired) {
            setSignupRes(res);
            setIsAppAuthState(true);
          }
        })
        .catch((err: any) => {
          toastMessage(err?.response?.data?.message, "error");
          console.log(
            "Error:",
            err.response && err.response.data && err.response.data.message
          );
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    // if (password !== password2) {
    //setAlert('Passwords do not match', 'danger');
    // } else {
    //register({ name, email, password });
    // return <NavLink to='/login' />;
    // }
  };
  const onOTPChange = async (value: string) => {
    setOtp(value);
    if (value.length === 6) {
      verifyOTPAuth(
        email.toLocaleLowerCase(),
        value,
        signupRes,
        isEmailAuthState ? "emailAuth" : "appAuth",
        true
      )
        .then((res: any) => {
          if (res?.data?.token && res.emptySessionId) {
            setTemporaryToken(res.data.token);
            setShowSessionsListView(true);
            return;
          }
          if (res?.data?.token) {
            dispatch(setToken(res.data.token));
            if (fromPath) {
              navigate(fromPath);
              return;
            }
            if (res.data.role === 5) {
              navigate("/partners/customers");
            } else {
              navigate("/home");
            }
          }
        })
        .catch((err: any) => {
          toastMessage(err.response.data.message, "error");
          console.log(
            "Error:",
            err.response && err.response.data && err.response.data.message
          );
        });
    }
  };
  const resendOTP = () => {
    setSeconds(30);
    setShowTimer(true);
    setIsLoading(true);
    resendRegisterOTP(email.toLocaleLowerCase(), true)
      .then(() => {
        toastMessage("OTP Resent To Mail", "info");
      })
      .catch((err: any) => {
        toastMessage(err.response.data.message, "error");
        console.log(
          "Error:",
          err.response && err.response.data && err.response.data.message
        );
      });
  };

  const onCloseSessionListView = () => {
    setShowSessionsListView(false);
    window.location.reload();
  };

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((seconds) => seconds - 1);
      }
      if (seconds <= 0) {
        clearInterval(myInterval);
        setShowTimer(false);
        setSeconds(30);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });
  return (
    <Fragment>
      <form className="pw-width-100 flex flex-col pw-register-form">
        <div className="">
          <div className="flex flex-row items-center pw-selected-plan pw-input-label !mt-0">
            <div className="flex flex-row items-center w-1/2 pw-input-label">
              <div>Account Type: </div>
              <div>
                <Select
                  className="pw-account-type-selection !text-sm !"
                  onChange={(event) =>
                    handleAccountTypeChange(event.target.value)
                  }
                  value={accountType}
                >
                  {accountTypes.map((eachType: any) => (
                    <MenuItem key={eachType} value={eachType}>
                      {eachType}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="pw-input-label">{t("email")}</div>
          <TextField
            type="email"
            variant="outlined"
            placeholder={t("Email Address")}
            size="small"
            name="email"
            className="pw-width-100 pw-input-field"
            value={email}
            onChange={(e) => onChange(e)}
            disabled={isEmailAuthState || isAppAuthState}
          />
          {emailError ? (
            <span className="pw-display-error">* {emailError}</span>
          ) : (
            ""
          )}
        </div>
        <div className="">
          <div className="pw-input-label">{t("password")}</div>
          {/* <TextField
        type='password'
        variant="outlined"
        placeholder='Password'
        size="small"
        name='password'
        className='pw-width-100 pw-input-field'
        value={password}
        onChange={e => onChange(e)}
      /> */}
          <OutlinedInput
            id="filled-adornment-password"
            type={showPassword ? "text" : "password"}
            name="password"
            size="small"
            placeholder={t("password")}
            sx={inputStyle}
            className="pw-width-100 pw-input-field"
            value={password}
            onChange={(e) => onChange(e)}
            disabled={isEmailAuthState || isAppAuthState}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onMouseDown={() => {
                    setShowPassword(true);
                  }}
                  onClick={() => {
                    setShowPassword(false);
                  }}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
          {!(isEmailAuthState || isAppAuthState) && (
            <div className="flex pw-forgot-text">
              <div
                className="pw-cursor-pointer"
                onClick={navigateToForgotPassword}
              >
                {t("Forgot Password")}
              </div>
            </div>
          )}
        </div>
        {(isEmailAuthState || isAppAuthState) && (
          <div className="flex flex-col pw-overflow-y-auto">
            <div className="pw-input-label">
              {isEmailAuthState
                ? "Enter OTP Sent to Registered Mail"
                : "Enter OTP From Authenticator App"}
            </div>
            <OtpInput
              value={otp}
              onChange={onOTPChange}
              numInputs={6}
              isInputNum={true}
              className={"pw-border w-100v"}
              separator={<span>&nbsp;</span>}
            />
            {isEmailAuthState && (
              <div className="pw-resend-otp-account  flex flex-row">
                <div
                  className={`pw-resend-text flex flex-row ${
                    !showTimer
                      ? "pw-cursor-pointer "
                      : "cursor-not-allowed opacity-50"
                  }`}
                  onClick={!showTimer ? resendOTP : () => {}}
                >
                  <div className={` ${showTimer ? "" : "pw-primary-color"}`}>
                    <RefreshIcon sx={{ fontSize: "18px" }} />
                    <span> {t("Resend OTP")}</span>
                  </div>
                </div>

                <div className={` ${showTimer ? "" : "pw-display-none"}`}>
                  00:
                  {zeroPad(seconds, 2)}
                </div>
              </div>
            )}
            {isAppAuthState && (
              <div className="flex pw-forgot-text">
                <div
                  className="pw-cursor-pointer"
                  onClick={() => {
                    setShowAppAuthSetup(true);
                  }}
                >
                  {t("2FA Account Recovery")}
                </div>
              </div>
            )}
          </div>
        )}
        {!(isEmailAuthState || isAppAuthState) && (
          <button
            type="submit"
            className={`pw-cursor-pointer ${
              isLoading ? "pw-neutral-background" : "pw-primary-button"
            }`}
            onClick={(e) => onSubmit(e)}
            disabled={!validateForm()}
          >
            {isLoading ? (
              <div className="flex flex-row gap-2 items-center justify-center">
                <span>{t("Signing")}</span>
                <CircularProgress size={20} />
              </div>
            ) : (
              <span>{t("Sign In")}</span>
            )}
          </button>
        )}
      </form>
      {showAppAuthSetup && (
        <AppAuthSetup
          email={email}
          open={showAppAuthSetup}
          onClose={() => {
            setShowAppAuthSetup(false);
          }}
          fromLogin={true}
        />
      )}
      {showSessionsListView && email?.length ? (
        <SessionsListView
          isDialog={true}
          open={showSessionsListView}
          onClose={onCloseSessionListView}
          username={email.toLocaleLowerCase()}
          temporaryToken={temporaryToken}
          className="w-full"
        ></SessionsListView>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default Login;
